import React, { useState, useEffect } from "react";

const BACKEND_URL = "https://supizza-backend.onrender.com";

export default function OrderHistory() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const user = JSON.parse(localStorage.getItem("userInfo"));
        if (!user) return setLoading(false);

        const token = localStorage.getItem("token");
        const res = await fetch(
          `${BACKEND_URL}/api/orders/user/${user.email}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          },
        );

        const data = await res.json();
        if (Array.isArray(data)) setOrders(data);
        else if (data.order) setOrders([data.order]);
        else setOrders([]);
      } catch (err) {
        console.error(err);
        setOrders([]);
      } finally {
        setLoading(false);
      }
    };

    fetchOrders();
  }, []);

  if (loading)
    return (
      <p className="text-center mt-10 text-gray-700">Loading your orders...</p>
    );

  if (orders.length === 0)
    return (
      <p className="text-center mt-10 text-gray-700">
        You haven’t placed any orders yet.
      </p>
    );

  return (
    <div className="p-6 space-y-8">
      {orders.map((order) => {
        const totalItems = order.cartItems.reduce(
          (acc, item) => acc + item.quantity,
          0,
        );

        return (
          <div
            key={order._id}
            className="bg-white p-6 rounded-2xl shadow-md border border-gray-100 space-y-6"
          >
            {/* Order Header */}
            <div className="flex justify-between items-center border-b pb-3">
              <h2 className="text-xl font-semibold text-gray-800">
                Order #{order.orderId || order._id}
              </h2>
              <span className="text-sm text-gray-500">
                {new Date(order.createdAt).toLocaleString()}
              </span>
            </div>

            {/* Cart Items */}
            <div className="space-y-2 text-gray-600 text-sm">
              {order.cartItems.map((item, i) => (
                <div key={i} className="flex justify-between">
                  <span>
                    {item.quantity} × {item.name}{" "}
                    <span className="text-gray-400 text-xs">({item.size})</span>
                  </span>
                  <span className="font-medium text-gray-800">
                    Rs {item.price * item.quantity}
                  </span>
                </div>
              ))}
            </div>

            {/* Order Totals */}
            <div className="border-t pt-4 space-y-2 text-gray-700 text-sm">
              <div className="flex justify-between">
                <span>Total Items</span>
                <span>{totalItems}</span>
              </div>
              <div className="flex justify-between">
                <span>Subtotal</span>
                <span>Rs {order.subtotal}</span>
              </div>
              <div className="flex justify-between">
                <span>Tax</span>
                <span>Rs {order.tax}</span>
              </div>
              <div className="flex justify-between">
                <span>Delivery</span>
                <span>Rs {order.delivery}</span>
              </div>
              <div className="flex justify-between text-lg font-semibold text-black pt-2 border-t">
                <span>Grand Total</span>
                <span>Rs {order.totalAmount}</span>
              </div>
              <div className="flex justify-between pt-1">
                <span>Payment Method</span>
                <span>{order.paymentMethod}</span>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
